import gsap from 'gsap'
import { setTitle, setTheme } from '../vuex/view/actions'
import { loading } from '../vuex/view/getters'

import Loader from '../components/Loader.vue'
import Container from '../components/Container.vue'
import Row from '../components/Row.vue'
import Column from '../components/Column.vue'

export default {
  ready () {
    this.setTitle(this.title)
    this.setTheme(this.theme)
  },
  data () {
    return {
      enableTransition: true,
      title: '',
      theme: 'standard'
    }
  },
  components: {
    Container,
    Row,
    Column,
    Loader
  },
  vuex: {
    actions: {
      setTitle,
      setTheme
    },
    getters: {
      loading
    }
  },
  watch: {
    title () {
      this.setTitle(this.title)
    }
  },
  route: {
    activate (transition) {
      if (!this.enableTransition) {
        transition.next()
        return
      }

      gsap.set(this.$el, {opacity: 0})
      gsap.to(this.$el, 0.5, {opacity: 1})

      transition.next()
    },
    deactivate (transition) {
      if (!this.enableTransition) {
        transition.next()
        return
      }

      gsap.to(this.$el, 0.5, {opacity: 0, onComplete: transition.next})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/view.js